import { useTranslation } from 'react-i18next'

import {
  Button,
  ButtonWithSpinner,
  CardTitle,
  Drawer,
  PackageCancelledIcon,
  Text,
  TextArea,
} from '@reveni-io/reveni-ui'

import { declineReasonMaxLength } from './constants'
import * as Styles from './styles'

const DeclineOnHoldDrawer = ({ show, onClose, onDeclineRequest, declining, declineReason, setDeclineReason }) => {
  const { t } = useTranslation()

  const handleChangeDeclineReason = e => setDeclineReason(e.target.value)

  return (
    <Drawer show={show} onClose={onClose} options={{ showHeaderActions: false }}>
      <CardTitle Icon={PackageCancelledIcon}>{t('Motivo de rechazo')}</CardTitle>
      <Styles.MainContainer>
        <Text type="bodySRegular">
          {t(
            'Añade el motivo por el que rechazas esta solicitud. Se guardará en el timeline de la transacción y podrás usarlo en tus templates de email.'
          )}
        </Text>
        <TextArea
          label={t('Motivo')}
          placeholder={t('Ej. El producto presenta signos de uso y no cumple con nuestra política de devoluciones.')}
          value={declineReason}
          onChange={handleChangeDeclineReason}
          maxLength={declineReasonMaxLength}
          showCounter
          fullWidth
        />
        <Styles.ButtonsContainer>
          <Button fullWidth variant="outlined" onClick={onClose} disabled={declining}>
            {t('Cancelar')}
          </Button>
          <ButtonWithSpinner
            fullWidth
            defaultLabel={t('Rechazar solicitud')}
            loadingLabel={t('Rechazando')}
            onClick={onDeclineRequest}
            loading={declining}
            disabled={declining}
          />
        </Styles.ButtonsContainer>
      </Styles.MainContainer>
    </Drawer>
  )
}

export default DeclineOnHoldDrawer
